// ヘッダーの状態をリセットする関数
function resetBusinessHeaderState() {
  // モバイルメニューを閉じる
  const mobileMenu = document.querySelector(".js-mobile-menu");
  if (mobileMenu) {
    mobileMenu.classList.remove("is-active");
  }
  
  // モバイル検索を閉じる
  const searchMobileContainer = document.querySelector(".business-header-search-mobile");
  if (searchMobileContainer) {
    searchMobileContainer.classList.remove("is-active");
  }
  
  // PCメニューを閉じる
  const menuButtons = document.querySelectorAll(".js-menuBtns li");
  const menuContents = document.querySelectorAll(".js-menuContent");
  menuButtons.forEach((button) => {
    button.classList.remove("is-active");
  });
  menuContents.forEach((content) => {
    content.classList.remove("is-show");
  });
  
  // モバイルメニューのアコーディオンを閉じる
  const mobileMenuItems = document.querySelectorAll(".business-header-mobile-menu-item");
  mobileMenuItems.forEach((item) => {
    item.classList.remove("is-open");
  });
  
  // bodyの状態をリセット
  document.body.classList.remove("is-menu-active");
  document.body.style.overflow = "";
}

// イベントリスナーの参照を保持するオブジェクト
const businessHeaderEventHandlers = {
  searchCloseHandlers: new WeakMap(),
  searchToggleHandlers: new WeakMap(),
  menuToggleHandlers: new WeakMap(),
  menuCloseHandlers: new WeakMap(),
  accordionHandlers: new WeakMap(),
  menuClickHandlers: new WeakMap(),
  menuMouseEnterHandlers: new WeakMap(),
  menuMouseLeaveHandlers: new WeakMap(),
  contentMouseEnterHandlers: new WeakMap(),
  contentMouseLeaveHandlers: new WeakMap(),
};

// イベントリスナーをクリーンアップする関数
function cleanupBusinessHeaderEventListeners() {
  // 検索関連
  const searchToggleBtn = document.querySelector(".js-mobile-search-toggle");
  const searchCloseBtn = document.querySelector(".js-mobile-search-close");
  
  if (searchToggleBtn && businessHeaderEventHandlers.searchToggleHandlers.has(searchToggleBtn)) {
    const handler = businessHeaderEventHandlers.searchToggleHandlers.get(searchToggleBtn);
    searchToggleBtn.removeEventListener("click", handler);
    businessHeaderEventHandlers.searchToggleHandlers.delete(searchToggleBtn);
  }
  
  if (searchCloseBtn && businessHeaderEventHandlers.searchCloseHandlers.has(searchCloseBtn)) {
    const handler = businessHeaderEventHandlers.searchCloseHandlers.get(searchCloseBtn);
    searchCloseBtn.removeEventListener("click", handler, true);
    businessHeaderEventHandlers.searchCloseHandlers.delete(searchCloseBtn);
  }
  
  // モバイルメニュー関連
  const menuToggleBtn = document.querySelector(".js-mobile-menu-toggle");
  const menuCloseBtns = document.querySelectorAll(".js-mobile-menu-close");
  
  if (menuToggleBtn && businessHeaderEventHandlers.menuToggleHandlers.has(menuToggleBtn)) {
    const handler = businessHeaderEventHandlers.menuToggleHandlers.get(menuToggleBtn);
    menuToggleBtn.removeEventListener("click", handler);
    businessHeaderEventHandlers.menuToggleHandlers.delete(menuToggleBtn);
  }
  
  menuCloseBtns.forEach((btn) => {
    if (businessHeaderEventHandlers.menuCloseHandlers.has(btn)) {
      const handler = businessHeaderEventHandlers.menuCloseHandlers.get(btn);
      btn.removeEventListener("click", handler);
      businessHeaderEventHandlers.menuCloseHandlers.delete(btn);
    }
  });
  
  // アコーディオン関連
  const accordionToggles = document.querySelectorAll(".business-header-mobile-menu-toggle");
  accordionToggles.forEach((toggle) => {
    if (businessHeaderEventHandlers.accordionHandlers.has(toggle)) {
      const handler = businessHeaderEventHandlers.accordionHandlers.get(toggle);
      toggle.removeEventListener("click", handler);
      businessHeaderEventHandlers.accordionHandlers.delete(toggle);
    }
  });
  
  // PCメニュー関連
  const menuButtons = document.querySelectorAll(".js-menuBtns li");
  menuButtons.forEach((button) => {
    if (businessHeaderEventHandlers.menuClickHandlers.has(button)) {
      const handler = businessHeaderEventHandlers.menuClickHandlers.get(button);
      button.removeEventListener("click", handler);
      businessHeaderEventHandlers.menuClickHandlers.delete(button);
    }
    if (businessHeaderEventHandlers.menuMouseEnterHandlers.has(button)) {
      const handler = businessHeaderEventHandlers.menuMouseEnterHandlers.get(button);
      button.removeEventListener("mouseenter", handler);
      businessHeaderEventHandlers.menuMouseEnterHandlers.delete(button);
    }
    if (businessHeaderEventHandlers.menuMouseLeaveHandlers.has(button)) {
      const handler = businessHeaderEventHandlers.menuMouseLeaveHandlers.get(button);
      button.removeEventListener("mouseleave", handler);
      businessHeaderEventHandlers.menuMouseLeaveHandlers.delete(button);
    }
    
    const content = button.querySelector(".js-menuContent");
    if (content) {
      if (businessHeaderEventHandlers.contentMouseEnterHandlers.has(content)) {
        const handler = businessHeaderEventHandlers.contentMouseEnterHandlers.get(content);
        content.removeEventListener("mouseenter", handler);
        businessHeaderEventHandlers.contentMouseEnterHandlers.delete(content);
      }
      if (businessHeaderEventHandlers.contentMouseLeaveHandlers.has(content)) {
        const handler = businessHeaderEventHandlers.contentMouseLeaveHandlers.get(content);
        content.removeEventListener("mouseleave", handler);
        businessHeaderEventHandlers.contentMouseLeaveHandlers.delete(content);
      }
    }
  });
  
  // グローバルイベントリスナー
  document.removeEventListener("click", handleSearchOutsideClick);
  document.removeEventListener("keydown", handleEscapeKey);
}

// スマホ検索の外側クリックハンドラー
function handleSearchOutsideClick(e) {
  const searchMobileContainer = document.querySelector(".business-header-search-mobile");
  if (!searchMobileContainer) return;
  
  // クローズボタンがクリックされた場合は処理しない
  if (
    e.target.closest(".js-mobile-search-close") ||
    e.target.closest(".business-header-search-mobile-close-btn")
  ) {
    return;
  }
  if (!searchMobileContainer.contains(e.target)) {
    searchMobileContainer.classList.remove("is-active");
  }
}

// ESCキーでモバイルメニューを閉じるハンドラー
function handleEscapeKey(e) {
  if (e.key === "Escape") {
    const mobileMenu = document.querySelector(".js-mobile-menu");
    if (mobileMenu && mobileMenu.classList.contains("is-active")) {
      mobileMenu.classList.remove("is-active");
      document.body.style.overflow = "";
    }
  }
}

// ビジネスヘッダーの初期化関数
function initializeBusinessHeader() {
  // 既存のイベントリスナーをクリーンアップ
  cleanupBusinessHeaderEventListeners();
  
  // 状態をリセット
  resetBusinessHeaderState();
  
  const breakpoint = 1080;
  const windowWidth = window.innerWidth;

  // スマホ検索アイコンのトグル
  (() => {
    const searchToggleBtn = document.querySelector(".js-mobile-search-toggle");
    const searchMobileContainer = searchToggleBtn?.closest(
      ".business-header-search-mobile"
    );
    const searchCloseBtn = document.querySelector(".js-mobile-search-close");

    // 閉じるボタンをクリックしたら閉じる
    if (searchCloseBtn) {
      const closeBtnContainer = searchCloseBtn.closest(
        ".business-header-search-mobile"
      );

      if (closeBtnContainer) {
        const closeHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          closeBtnContainer.classList.remove("is-active");
        };
        businessHeaderEventHandlers.searchCloseHandlers.set(searchCloseBtn, closeHandler);
        searchCloseBtn.addEventListener("click", closeHandler, true);
      }
    }

    if (searchToggleBtn && searchMobileContainer) {
      const toggleHandler = (e) => {
        e.stopPropagation();
        searchMobileContainer.classList.toggle("is-active");
      };
      businessHeaderEventHandlers.searchToggleHandlers.set(searchToggleBtn, toggleHandler);
      searchToggleBtn.addEventListener("click", toggleHandler);

      // 外側をクリックしたら閉じる
      document.addEventListener("click", handleSearchOutsideClick);
    }
  })();

  // スマホメニューのトグル
  (() => {
    const menuToggleBtn = document.querySelector(".js-mobile-menu-toggle");
    const menuCloseBtns = document.querySelectorAll(".js-mobile-menu-close");
    const mobileMenu = document.querySelector(".js-mobile-menu");

    if (menuToggleBtn && mobileMenu) {
      const toggleHandler = (e) => {
        e.stopPropagation();
        mobileMenu.classList.add("is-active");
        document.body.style.overflow = "hidden";
      };
      businessHeaderEventHandlers.menuToggleHandlers.set(menuToggleBtn, toggleHandler);
      menuToggleBtn.addEventListener("click", toggleHandler);

      const closeHandler = (e) => {
        e.stopPropagation();
        mobileMenu.classList.remove("is-active");
        document.body.style.overflow = "";
      };

      menuCloseBtns.forEach((btn) => {
        businessHeaderEventHandlers.menuCloseHandlers.set(btn, closeHandler);
        btn.addEventListener("click", closeHandler);
      });

      // ESCキーで閉じる
      document.addEventListener("keydown", handleEscapeKey);

      // アコーディオンの開閉
      const accordionToggles = mobileMenu.querySelectorAll(
        ".business-header-mobile-menu-toggle"
      );

      accordionToggles.forEach((toggle) => {
        const accordionHandler = (e) => {
          e.stopPropagation();
          const menuItem = toggle.closest(".business-header-mobile-menu-item");
          const isOpen = menuItem.classList.contains("is-open");

          // 他のアコーディオンを閉じる
          mobileMenu
            .querySelectorAll(".business-header-mobile-menu-item.is-open")
            .forEach((item) => {
              if (item !== menuItem) {
                item.classList.remove("is-open");
              }
            });

          // クリックしたアコーディオンを開閉
          if (isOpen) {
            menuItem.classList.remove("is-open");
          } else {
            menuItem.classList.add("is-open");
          }
        };
        businessHeaderEventHandlers.accordionHandlers.set(toggle, accordionHandler);
        toggle.addEventListener("click", accordionHandler);
      });
    }
  })();

  // PCメニュー
  (() => {
    const menuButtons = Array.from(
      document.querySelectorAll(".js-menuBtns li")
    );

    const menuSelector = ".js-menuContent";

    if (!menuButtons.length) return;

    const updateBodyState = () => {
      const businessMenus = document.querySelectorAll(".business-menu");
      let hasOpenMenu = false;

      businessMenus.forEach((menu) => {
        if (menu.classList.contains("is-show")) {
          hasOpenMenu = true;
        }
      });

      if (hasOpenMenu) {
        document.body.classList.add("is-menu-active");
      } else {
        document.body.classList.remove("is-menu-active");
      }
    };

    const closeAllMenus = () => {
      menuButtons.forEach((button) => {
        const content = button.querySelector(menuSelector);
        if (content) content.classList.remove("is-show");
        button.classList.remove("is-active");
      });
    };

    if (windowWidth <= breakpoint) {
      menuButtons.forEach((button) => {
        const content = button.querySelector(menuSelector);
        if (!content) return;

        const clickHandler = () => {
          const isCurrentlyOpen = content.classList.contains("is-show");
          closeAllMenus();
          if (!isCurrentlyOpen) {
            content.classList.add("is-show");
            button.classList.add("is-active");
          }
          updateBodyState();
        };
        businessHeaderEventHandlers.menuClickHandlers.set(button, clickHandler);
        button.addEventListener("click", clickHandler);
      });
    } else {
      let closeTimer = null;

      menuButtons.forEach((button) => {
        const content = button.querySelector(menuSelector);
        if (!content) return;

        const openMenu = () => {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
          closeAllMenus();
          content.classList.add("is-show");
          button.classList.add("is-active");
          updateBodyState();
        };

        const closeMenu = () => {
          if (closeTimer) {
            clearTimeout(closeTimer);
          }
          closeTimer = setTimeout(() => {
            closeAllMenus();
            updateBodyState();
            closeTimer = null;
          }, 100);
        };

        const contentMouseEnterHandler = () => {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        };

        businessHeaderEventHandlers.menuMouseEnterHandlers.set(button, openMenu);
        businessHeaderEventHandlers.menuMouseLeaveHandlers.set(button, closeMenu);
        businessHeaderEventHandlers.contentMouseEnterHandlers.set(content, contentMouseEnterHandler);
        businessHeaderEventHandlers.contentMouseLeaveHandlers.set(content, closeMenu);

        button.addEventListener("mouseenter", openMenu);
        button.addEventListener("mouseleave", closeMenu);
        content.addEventListener("mouseenter", contentMouseEnterHandler);
        content.addEventListener("mouseleave", closeMenu);
      });
    }
  })();
}

// ヘッダーの背景透明化処理（KV上にいる時）
let headerTransparencyInitialized = false;
let headerTransparencyScrollHandler = null;
let headerTransparencyResizeHandler = null;

function initializeHeaderTransparency() {
  const header = document.querySelector(".business-header");
  const kvSection = document.querySelector(".kv-v2");

  if (!header || !kvSection) return;

  const updateHeaderState = () => {
    const scrollY = window.scrollY || window.pageYOffset;

    // 少しでも下にスクロールしたら透明解除
    if (scrollY > 0) {
      header.classList.remove("is-transparent");
    } else {
      header.classList.add("is-transparent");
    }
  };

  // 初回実行
  updateHeaderState();

  // スクロールイベント（重複を防ぐ）
  if (!headerTransparencyInitialized) {
    let ticking = false;
    headerTransparencyScrollHandler = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateHeaderState();
          ticking = false;
        });
        ticking = true;
      }
    };
    window.removeEventListener("scroll", headerTransparencyScrollHandler, { passive: true });
    window.addEventListener("scroll", headerTransparencyScrollHandler, { passive: true });

    // リサイズイベント
    headerTransparencyResizeHandler = () => {
      updateHeaderState();
    };
    window.removeEventListener("resize", headerTransparencyResizeHandler);
    window.addEventListener("resize", headerTransparencyResizeHandler);

    headerTransparencyInitialized = true;
  } else {
    // 既に初期化されている場合は状態を更新
    updateHeaderState();
  }
}

// DOMContentLoaded時の初期化
document.addEventListener("DOMContentLoaded", () => {
  initializeBusinessHeader();

  // 表：高さを揃える

  (() => {
    const length = 9;

    let headPadding = 0;

    for (let i = 1; i <= length; i += 1) {
      const targets = Array.from(document.querySelectorAll(`.js-fixH-${i}`));

      if (!targets.length) continue;

      let maxHeight = 0;

      targets.forEach((element) => {
        const elementHeight = element.clientHeight;

        if (elementHeight > maxHeight) {
          maxHeight = elementHeight;
        }
      });

      targets.forEach((element) => {
        const style = window.getComputedStyle(element);

        const paddingTop = parseFloat(style.paddingTop) || 0;

        const paddingBottom = parseFloat(style.paddingBottom) || 0;

        const contentHeight = Math.max(
          maxHeight - paddingTop - paddingBottom,

          0
        );

        element.style.height = `${contentHeight}px`;
      });

      if (i === 1 || i === 2) {
        headPadding += maxHeight;
      }
    }

    const blockHead = document.querySelector(".blockHead");

    if (blockHead) {
      const offset = windowWidth <= breakpoint ? 250 : 311;

      blockHead.style.paddingTop = `${headPadding + offset}px`;
    }
  })();

  // 表：幅調整

  (() => {
    const blocks = Array.from(document.querySelectorAll(".table-wrap .block"));

    const group = document.querySelector(".table-wrap .group");

    if (!blocks.length || !group) return;

    const additionalSpacing = windowWidth <= breakpoint ? 30 : 40;

    const extraOffset = windowWidth <= breakpoint ? 100 : 200;

    const totalWidth =
      blocks.reduce(
        (sum, element) => sum + element.offsetWidth + additionalSpacing,

        0
      ) + extraOffset;

    group.style.width = `${totalWidth}px`;
  })();

  // 表：more

  (() => {
    const target = document.querySelector(".js-tableMoreArea");

    const button = document.querySelector(".js-tableMore");

    if (!target || !button) return;

    button.addEventListener("click", () => {
      target.classList.toggle("is-limit");

      button.style.display = "none";
    });
  })();

  // PC/SP改行切り替えの空白の解消

  (() => {
    if (windowWidth <= breakpoint) {
      document.querySelectorAll(".m-pc").forEach((element) => {
        element.remove();
      });
    } else {
      document.querySelectorAll(".m-sp").forEach((element) => {
        element.remove();
      });
    }
  })();

  // タブ切り替え

  (() => {
    const tabButtons = Array.from(document.querySelectorAll(".js-tabBtns li"));

    const tabAreas = Array.from(document.querySelectorAll(".js-tabArea"));

    if (!tabButtons.length || !tabAreas.length) return;

    tabButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        tabButtons.forEach((btn) => btn.classList.remove("is-active"));

        tabAreas.forEach((area) => area.classList.remove("is-show"));

        button.classList.add("is-active");

        const targetArea = tabAreas[index];

        if (targetArea) {
          targetArea.classList.add("is-show");
        }
      });
    });
  })();

  // ヘッダーの背景透明化（KV上にいる時）を初期化
  initializeHeaderTransparency();
});

// ページ遷移時にヘッダーを再初期化（Turbo/SPA対応）
if (typeof Turbo !== "undefined") {
  document.addEventListener("turbo:load", function () {
    // ページ遷移後に再初期化
    setTimeout(() => {
      initializeBusinessHeader();
      initializeHeaderTransparency();
    }, 0);
  });
  document.addEventListener("turbo:before-visit", function () {
    // ページ遷移前に状態をリセット
    resetBusinessHeaderState();
  });
}

// 通常のページ遷移時にもリセット
window.addEventListener("beforeunload", function () {
  resetBusinessHeaderState();
});

// ページロード時にも再初期化
window.addEventListener("load", function () {
  // 既に初期化されている場合は再初期化
  setTimeout(() => {
    initializeBusinessHeader();
    initializeHeaderTransparency();
  }, 0);
});
